import { z } from 'zod';

export const PaddingSettingSchema = z.object({
  top: z.number().optional(),
  bottom: z.number().optional(),
  left: z.number().optional(),
  right: z.number().optional(),
});

export type PaddingSetting = z.infer<typeof PaddingSettingSchema>;
